/* Nightpass - deplacement des filtres actifs sous le nombre de resultats.

   Dawn genere les puces de filtres actifs dans la colonne de gauche. On les
   deplace une seule fois vers la barre de tri, dans la colonne des resultats.

   Pourquoi deplacer le noeud plutot que le recopier : Dawn met a jour ces
   puces en reecrivant l'interieur de .active-facets-desktop
   (renderActiveFacets), sans jamais remplacer l'element lui-meme. Une fois
   deplace, il continue donc d'etre alimente normalement a chaque filtrage,
   sans rechargement et sans code supplementaire de notre part.

   La classe posee sur <html> permet au CSS de masquer les puces jusqu'au
   deplacement. Elle est posee par ce script : si le JavaScript ne s'execute
   pas, la regle de masquage ne s'applique jamais et les puces restent
   visibles a leur emplacement d'origine. */

(function () {
  if (window.__npFacetsReady) return;
  window.__npFacetsReady = true;

  document.documentElement.classList.add('np-facets-js');

  function move() {
    var chips = document.querySelector('.active-facets-desktop');
    var host = document.querySelector('.facets-vertical-sort .facets-vertical-form');
    if (!chips || !host) {
      /* Rien a deplacer (mobile, pas de filtres) : on rend la main au CSS. */
      document.documentElement.classList.add('np-facets-moved');
      return;
    }
    if (chips.parentNode !== host) host.appendChild(chips);
    document.documentElement.classList.add('np-facets-moved');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', move);
  } else {
    move();
  }

  /* L'editeur de theme recharge les sections a chaud. */
  document.addEventListener('shopify:section:load', move);

  /* Filet de securite : si quoi que ce soit bloque, on ne laisse pas les
     puces masquees indefiniment. */
  setTimeout(function () {
    document.documentElement.classList.add('np-facets-moved');
  }, 2000);
})();
